"use client";

import { Employer, GovernmentEmployerBasicRegistrationDto } from "@entities/employer";
import { GovernmentEmployerBasicDetails, GovernmentEmployerBasicRegistrationForm } from "@features/registration";
import { Button, Dialog, DialogBody, DialogClose, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@ubud-ui/react-ui-kit";
import { useState } from "react";

function EditDialog({
  payload,
  onSubmit,
  hideAgency,
}: {
  payload?: GovernmentEmployerBasicRegistrationDto | null;
  onSubmit?: (payload: GovernmentEmployerBasicRegistrationDto) => void;
  hideAgency?: boolean;
}) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleSubmit = (data: GovernmentEmployerBasicRegistrationDto) => {
    if (onSubmit) {
      setIsOpen(false);
      onSubmit(data);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => setIsOpen(open)}>
      <DialogTrigger asChild>
        <Button className="text-sm font-bold m-0 p-0 w-auto h-auto" variant="link">
          Ubah
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit informasi umum</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <GovernmentEmployerBasicRegistrationForm formValue={payload || undefined} onSubmit={handleSubmit} hideAgency={hideAgency}>
            <div className="sticky bottom-0 grid grid-cols-2 gap-3 bg-white py-6">
              <DialogClose asChild>
                <Button className="text-sm font-bold" variant="outline">
                  Batal
                </Button>
              </DialogClose>
              <Button className="text-sm font-bold" variant="default">
                Simpan
              </Button>
            </div>
          </GovernmentEmployerBasicRegistrationForm>
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}

export function GovernmentEmployerBasicRegistrationPreview({
  basic,
  onSubmit,
  hideAgency,
}: {
  basic?: GovernmentEmployerBasicRegistrationDto | null;
  onSubmit?: (payload: GovernmentEmployerBasicRegistrationDto) => void;
  hideAgency?: boolean;
}) {
  return (
    <div>
      <div className="mb-4 flex items-center gap-4">
        <h4 className="flex-1 text-base font-bold">Informasi umum</h4>
        <EditDialog payload={basic} onSubmit={onSubmit} hideAgency={hideAgency} />
      </div>
      <GovernmentEmployerBasicDetails
        employer={
          {
            name: basic?.name,
            employerable: {
              establishmentDate: basic?.establishment_date,
            },
            description: basic?.description,
            phone: basic?.phone,
            email: basic?.email,
            website: basic?.website,
            logoFileId: basic?.logo,
          } as Employer
        }
      />
    </div>
  );
}
